export default "__VITE_ASSET__CHEtRgnm__"